import { routes } from "../../../constants";
import { baseRouteMaker } from "../../../constants/routeConsts";

export const useOffersAndPackagesMenuUtils = (t) => {
  const tempMenuGroup = [];

  /* menuItemOffer */
  const menuItemOffer = {
    id: "offer",
    title: t("Modules.Offer.OfferForm.title"),
    url: baseRouteMaker(routes.OFFER),
  };
  tempMenuGroup.push(menuItemOffer);
  /* menuItemOffer */

  /* menuItemPackages */
  const menuItemPackages = {
    id: "packages",
    title: t("Modules.Ads.packages"),
    url: baseRouteMaker(routes.PACKAGES),
  };
  tempMenuGroup.push(menuItemPackages);
  /* menuItemPackages */

  return tempMenuGroup;
};
